<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 16.75C13.728 16.75 16.75 13.728 16.75 10C16.75 6.27208 13.728 3.25 10 3.25C6.27208 3.25 3.25 6.27208 3.25 10C3.25 13.728 6.27208 16.75 10 16.75Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 13V13.0075" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M10.0005 10.75C10.0005 9.5206 11.5005 9.94893 11.5005 8.5C11.5005 7.67157 10.8289 7 10.0005 7C9.44525 7 8.96052 7.30165 8.70117 7.75" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'QuestionMarkCircleIcon',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    }
  }
}
</script>

<style scoped></style>